














import Vue from 'vue'

import TableDatalog from './table-datalog.vue'
import TableItems from './table-items.vue'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'

export default Vue.extend({
  name: 'DatalogManager',
  components: { Splitpanes, Pane, TableDatalog, TableItems },
  data() {
    return {
      selectedId: -1,
    }
  },
  methods: {
    onSelectedIdChanged(id: number) {
      this.selectedId = id
    },
  },
})
